export const FETCH_JOB_DEAL_MEMOS_REQUEST = 'FETCH_JOB_DEAL_MEMOS_REQUEST';
export const FETCH_JOB_DEAL_MEMOS_SUCCESS = 'FETCH_JOB_DEAL_MEMOS_SUCCESS';
export const FETCH_JOB_DEAL_MEMOS_FAIL = 'FETCH_JOB_DEAL_MEMOS_FAIL';

export const FETCH_JOB_INVOICE_MEMOS_REQUEST =
  'FETCH_JOB_INVOICE_MEMOS_REQUEST';
export const JOB_INVOICE_MEMOS_INITIALIZE = 'JOB_INVOICE_MEMOS_INITIALIZE';
export const FETCH_JOB_INVOICE_MEMOS_SUCCESS =
  'FETCH_JOB_INVOICE_MEMOS_SUCCESS';
export const FETCH_JOB_INVOICE_MEMOS_FAIL = 'FETCH_JOB_INVOICE_MEMOS_FAIL';

export const FETCH_INVOICE_BY_MEMO_REQUEST = 'FETCH_INVOICE_BY_MEMO_REQUEST';
export const FETCH_INVOICE_BY_MEMO_SUCCESS = 'FETCH_INVOICE_BY_MEMO_SUCCESS';
export const FETCH_INVOICE_BY_MEMO_FAIL = 'FETCH_INVOICE_BY_MEMO_FAIL';

export const UPDATE_INVOICE_REQUEST = 'UPDATE_INVOICE_REQUEST';
export const UPDATE_INVOICE_SUCCESS = 'UPDATE_INVOICE_SUCCESS';
export const UPDATE_INVOICE_FAIL = 'UPDATE_INVOICE_FAIL';

export const UPDATE_INVOICE_MEMO_REQUEST = 'UPDATE_INVOICE_MEMO_REQUEST';
export const UPDATE_INVOICE_MEMO_SUCCESS = 'UPDATE_INVOICE_MEMO_SUCCESS';
export const UPDATE_INVOICE_MEMO_FAIL = 'UPDATE_INVOICE_MEMO_FAIL';

export const SEND_JOB_INVOICE_REQUEST = 'SEND_JOB_INVOICE_REQUEST';
export const SEND_JOB_INVOICE_SUCCESS = 'SEND_JOB_INVOICE_SUCCESS';
export const SEND_JOB_INVOICE_FAIL = 'SEND_JOB_INVOICE_FAIL';

export const PAY_APPROVED_INVOICE_BY_WALLET_REQUEST =
  'PAY_APPROVED_INVOICE_BY_WALLET_REQUEST';
export const PAY_APPROVED_INVOICE_BY_BANK_REQUEST =
  'PAY_APPROVED_INVOICE_BY_BANK_REQUEST';

export const PAY_APPROVED_INVOICE_SUCCESS = 'PAY_APPROVED_INVOICE_SUCCESS';
export const PAY_APPROVED_INVOICE_FAIL = 'PAY_APPROVED_INVOICE_FAIL';
export const PAY_APPROVED_INVOICE_RESET = 'PAY_APPROVED_INVOICE_RESET';

export const APPROVE_INVOICE_REQUEST = 'APPROVE_INVOICE_REQUEST';
export const APPROVE_INVOICE_SUCCESS = 'APPROVE_INVOICE_SUCCESS';
export const APPROVE_INVOICE_FAIL = 'APPROVE_INVOICE_FAIL';

export const DISPUTE_INVOICE_REQUEST = 'DISPUTE_INVOICE_REQUEST';
export const DISPUTE_INVOICE_SUCCESS = 'DISPUTE_INVOICE_SUCCESS';
export const DISPUTE_INVOICE_FAIL = 'DISPUTE_INVOICE_FAIL';

export const DOWNLOAD_REPORTS_REQUEST = 'DOWNLOAD_REPORTS_REQUEST';
export const DOWNLOAD_REPORTS_SUCCESS = 'DOWNLOAD_REPORTS_SUCCESS';
export const DOWNLOAD_REPORTS_FAIL = 'DOWNLOAD_REPORTS_FAIL';

export const FETCH_REPORTS_REQUEST = 'FETCH_REPORTS_REQUEST';
export const FETCH_REPORTS_SUCCESS = 'FETCH_REPORTS_SUCCESS';
export const FETCH_REPORTS_FAIL = 'FETCH_REPORTS_FAIL';

export const UPDATE_WRAP_PAY_SELECTED_OPTION_REQUEST =
  'UPDATE_WRAP_PAY_SELECTED_OPTION_REQUEST';
export const UPDATE_WRAP_PAY_SELECTED_OPTION_SUCCESS =
  'UPDATE_WRAP_PAY_SELECTED_OPTION_SUCCESS';
export const UPDATE_WRAP_PAY_SELECTED_OPTION_FAIL =
  'UPDATE_WRAP_PAY_SELECTED_OPTION_FAIL';

export const RESET_JOB_PAID_BY = 'RESET_JOB_PAID_BY';

export const GENERATE_STRIPE_PAYMENT_LINK_REQUEST = 'GENERATE_STRIPE_PAYMENT_LINK_REQUEST';
export const GENERATE_STRIPE_PAYMENT_LINK_SUCCESS = 'GENERATE_STRIPE_PAYMENT_LINK_SUCCESS';
export const GENERATE_STRIPE_PAYMENT_LINK_FAIL    = 'GENERATE_STRIPE_PAYMENT_LINK_FAIL';
export const GENERATE_STRIPE_PAYMENT_LINK_RESET   = 'GENERATE_STRIPE_PAYMENT_LINK_RESET';
